import React, { useState } from "react";
import { Button, Header, Message, Container, Segment, Form, Grid } from 'semantic-ui-react'

import { useAuth } from "../contexts/AuthContext"
//import { Link, useHistory , withRouter} from "react-router-dom"
import { Link, useNavigate } from "@reach/router";

// https://github.com/WebDevSimplified/React-Firebase-Auth/blob/c3554089313682dc0f216adb38d4ccf3addcd39f/src/components/Signup.js
// https://reactrouter.com/web/guides/quick-start 

function SignUp() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");


  const { signup } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  // const history = useHistory()
  const navigate = useNavigate()


  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setError("")
      setLoading(true)
      await signup(email, password, displayName)
      //history.push("/")
      navigate("/");
    } catch {
      setError("Failed to create an account")
    }
    setEmail("");
    setPassword("");
    setDisplayName("");
    setLoading(false)
  }

  return (
    <Container style={{ padding: 10 }}>
      <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
        <Grid.Column style={{ maxHeigth: 200 }}>
          <div >
            {error !== null && (
              <div style={{ color: "red" }}>
                {error}
              </div>
            )}
          </div>

          <Header as='h2' color='teal' textAlign='center'>
            SignUp
      </Header>
          <Form size='large'>
            <Segment stacked>

              <Form.Input
                type="text"
                style={{ padding: 2 }}

                name="displayName"
                value={displayName}
                placeholder="Enter Your Name"
                id="displayName"
                onChange={(e) => setDisplayName(e.target.value)}
              />

              <Form.Input
                type="email"
                style={{ padding: 2 }}
                name="userEmail"
                value={email}
                placeholder="Enter your email"
                id="userEmail"
                onChange={(e) => setEmail(e.target.value)}
              />

              <Form.Input
                type="password"
                style={{ padding: 2 }}
                name="userPassword"
                value={password}
                placeholder="Your Password"
                id="userPassword"
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button color='teal' fluid size='large' disabled={loading}
                onClick={event => {
                  handleSubmit(event);
                }}
              >
                Sign up
          </Button>
            </Segment>
          </Form>
          <Message>
            Already have an account?
        <Link to="/" >
              Sign in here
          </Link>
          </Message>

        </Grid.Column>
      </Grid>



    </Container>
  );
};
export default SignUp;